import queryString from 'query-string';
import { defaultCategory } from 'config';
import { slugify,cleanFacet } from 'utils';
import PubSub from 'services/PubSub/';

let actions = [];

const FilterService = (props) => {
    const _setup = () => {
        if(actions.length){
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }

        actions.push(PubSub.register('filter_setSpecification', (payload) => setSpecification(payload.value.specification)));
        actions.push(PubSub.register('filter_setSpecifications', (payload) => setSpecifications(payload.value.specifications)));
        actions.push(PubSub.register('filter_setBrand', (payload) => setBrand(payload.value.brand)));
        actions.push(PubSub.register('filter_setBrands', (payload) => setBrands(payload.value.brands)));
        actions.push(PubSub.register('filter_setOrder', (payload) => setOrder(payload.value.order)));
    };

    const getPage = () => {
        const params = queryString.parse(props.location.search);
        return params.page || 1;
    };

    const getPromoName = (title) => {
        const params = queryString.parse(props.location.search);
        return params.nombre_promo || title;
    };

    const setPage = (_page) => {
        if (!_page) return false;
        page = _page;
        change(false);
    };

    const getSearch = () => {
        const params = queryString.parse(props.location.search);
        return params.ft || "";
    };

    const getCollections = () => {
        const params = queryString.parse(props.location.search);
        return params.fq || "";
    };

    const getCategories = () => {
        categories = [];
        const { params } = props.match;

        for (let i = 1; i < 4; i++) {
            if (params['category' + i]) {
                categories.push(params['category' + i]);
            }
        }

        return categories.length > 0 ? categories : ((search !== '' || collections !== '') ? ['all'] : defaultCategory.concat([]));
    };

    const getOrder = () => {
        const params = queryString.parse(props.location.search);
        return params.o || "";
    };

    const getSpecification = () => {
        const params = queryString.parse(props.location.search);
        if (!params.s) return [];
        return params.s.split(',').map((item) => {
            item = item.split(':');
            return {
                id: item[0],
                slug: item[1]
            }
        });
    };

    const setSpecification = (specification) => {
        if (!specification) return false;
        specification = {
            slug: specification.Name,
            id: specification.id
        };
        const index = specifications.map((item) => item.slug).indexOf(specification.slug);
        if (index === -1) {
            specifications.push(specification);
        } else {
            specifications.splice(index, 1);
        }
        page = 1;
        change();
    };

    const setSpecifications = (_specifications) => {
        specifications = _specifications.map(specification => {
            return {
                slug: specification.Name,
                id: specification.id
            };
        });
        page = 1;
        change();
    };

    const clearSpecification = () => {
        specifications = [];
        page = 1;
        change();
    };

    const getBrands = () => {
        const params = queryString.parse(props.location.search);
        if (!params.b) return [];
        return params.b.split(',');
    };

    const setBrand = (brand) => {
        if (!brand) return false;

        if (search) {
            brand = cleanFacet(brand.Name);
        }
        else{
            brand = slugify(brand.Name);
        }

        const index = brands.indexOf(brand);
        if (index === -1) {
            brands.push(brand);
        } else {
            brands.splice(index, 1);
        }
        page = 1;
        change();
    };

    const setBrands = (_brands) => {
        if (search) {
            brands = _brands.map(brand => cleanFacet(brand.Name));
        }
        else{
            brands = _brands.map(brand => slugify(brand.Name));
        }
        page = 1;
        change();
    };

    const clearBrands = () => {
        brands = [];
        page = 1;
        change();
    };

    const setOrder = (_order) => {
        order = _order;
        change();
    };

    const change = (reload = true) => {
        const _brands = brands.length > 0 ? brands.join(",") : false;
        const _specifications = specifications.length > 0 ? specifications.map((item) => `${item.id}:${item.slug}`).join(",") : false;
        const _order = order !== '' ? order : false;
        const _page = page !== 0 ? page : false;
        const _collections = collections !== 0 ? collections : false;
        const { history, location } = props;

        let params = queryString.parse(location.search);

        if (_brands) {
            params.b = _brands;
        } else if (params.b) {
            delete params.b;
        }

        if (_specifications) {
            params.s = _specifications;
        } else if (params.s) {
            delete params.s;
        }

        if (_order) {
            params.o = _order;
        } else if (params.o) {
            delete params.o;
        }

        if (_page) {
            params.page = _page;
        } else if (params.page) {
            delete params.page;
        }

        if (_collections) {
            params.fq = _collections;
        } else if (params.fq) {
            delete params.fq;
        }

        history.push(location.pathname + (params ? '?' + queryString.stringify(params) : ""));

        if (reload) {
            setTimeout(function () {
                PubSub.dispatch('filter_change');
            }, 0);
        }
    };

    let search = getSearch();
    let order = getOrder();
    let collections = getCollections();
    let categories = getCategories();
    let brands = getBrands();
    let specifications = getSpecification();
    let page = parseInt(getPage());

    _setup();

    return {
        search,
        order,
        collections,
        categories,
        brands,
        specifications,
        page,
        getPage,
        getPromoName,
        setPage,
        getSearch,
        getCollections,
        getCategories,
        getOrder,
        setBrand,
        setBrands,
        clearBrands,
        getSpecification,
        setSpecifications,
        clearSpecification
    }
};

export default FilterService;
